import type { FeedType } from "seenspire-api-client";

const INFOTAINMENT = "INFOTAINMENT";

export const LICENSED_INFOTAINMENT = "LICENSED_INFOTAINMENT" as FeedType;

export const isInfotainmentType = (feedType?: string | null) =>
  feedType === INFOTAINMENT || feedType === LICENSED_INFOTAINMENT;
